<template>
  <header class="modal-header">
    <h3 class="ampTitle">
      {{ t("ccOnBoarding.popupMessage.draftFoundHeader") }}
    </h3>
  </header>
  <section class="modal-card-body">
    <div class="frame-36260">
      <div
        class="you-ve-reached-the-maximum-limit-for-otp-requests-please-continue-to-the-next-step"
      >
        {{ t("ccOnBoarding.popupMessage.draftFoundBody") }}
      </div>
    </div>
  </section>
  <footer class="modal-footer">
    <div class="close-button">
      <button
        class="btn-close2"
        aria-label="close"
        @click="emit('startNewApplication')"
      >
        <p class="text">{{ t("ccOnBoarding.popupMessage.no") }}</p>
      </button>
    </div>
    <div class="close-button">
      <button
        class="btn-close1"
        aria-label="close"
        @click="emit('resumeApplication')"
      >
        <p class="text">{{ t("ccOnBoarding.popupMessage.yes") }}</p>
      </button>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import i18n from "@/plugin/i18n";
import { deviceDetect } from "mobile-device-detect";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

// @/plugin/i18n
const emit = defineEmits(["resumeApplication", "startNewApplication"]);

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const { t } = i18n.global;
// const props = defineProps({});

const isContinue = () => {
  //   emit("confirmation");
};
</script>

<style scoped>
.delete {
  text-align: end;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  padding: 0 20px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}

.modal-content {
  background-color: white;
  border-radius: 5px;
  max-width: 500px;
  max-height: 100%;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
}

.modal-header-terms {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
  text-align: center;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.btn-close1 {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1001; /* Set a higher z-index to ensure it's above the PDF content and header */
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 20px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.btn-close2 {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1001; /* Set a higher z-index to ensure it's above the PDF content and header */
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid;
  background-color: transparent;
  font-size: 14px;
  font-weight: 600;
  color: black;
}

.close-button {
  display: flex;
  width: 100px;
  margin-right: 4px;
}

.pdf-container {
  width: 100%;
}

.modal-card-body {
  border-bottom: 1px solid #dbdfea;
  border-top: 1px solid #dbdfea;
}

.modal-card-body-usagePolicy {
  border-bottom: 1px solid #dbdfea;
  border-top: 1px solid #dbdfea;
}

/*
  .modal-card {
  margin-top: 10px;
  max-height: calc(100vh - 160px);
  overflow: auto;
  position: relative;
  width: calc(100% - 2em);
  } */
@media screen and (min-width: 300px) {
  .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 640px;
  }
}

.ampTitle {
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 0;
}

.ampTitle-terms {
  color: var(--Primary-Active, #ac2887);
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 0;
}

.frame-36260,
.frame-36260 * {
  box-sizing: border-box;
}
.frame-36260 {
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.you-ve-reached-the-maximum-limit-for-otp-requests-please-continue-to-the-next-step {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--body-regular-font-family, "Outfit-Regular", sans-serif);
  font-size: var(--body-regular-font-size, 16px);
  line-height: var(--body-regular-line-height, 130%);
  font-weight: var(--body-regular-font-weight, 400);
  position: relative;
  flex: 1;
}

.usage_policy {
  color: var(--Web-Black-Medium, #757575);
  /* Body (Regular) */
  font-family: Outfit;
  /* font-size: 16px; */
  font-size: 14px;
  font-style: normal;
  /* font-weight: 400; */
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}

.unsuccessful-content {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--body-regular-font-family, "Outfit-Regular", sans-serif);
  font-size: var(--body-regular-font-size, 16px);
  line-height: var(--body-regular-line-height, 130%);
  font-weight: var(--body-regular-font-weight, 400);
  position: relative;
  flex: 1;
  text-align: center;
}

.modal-footer {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: white;
}

.modal-footer-terms {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.popup-sign,
.popup-sign * {
  box-sizing: border-box;
}
.popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  margin: auto;
}
.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 10px);
  top: calc(50% - 10px);
  overflow: visible;
}

.top-navigation-24 {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 3%;
  top: 24px;
  overflow: hidden;
}

.modal-content-terms:is(.Mobile) {
  max-width: 100%;
}

.modal-card-body-usagePolicy:is(.Mobile) {
  overflow-y: scroll;
}

@media screen and (max-width: 600px) {
  .modal-card-body-usagePolicy:is(.Mobile) {
    height: 400px;
  }
}

@media screen and (max-width: 900px) {
  .close-button {
    display: flex;
    margin-right: 4px;
  }
}

.insideButton {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-close1:disabled,
.btn-close2:disabled {
  display: flex;
  justify-content: center;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: black;
}

/* .btn-close1:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  } */

/* .btn-close1:is(.Mobile):disabled {
    width: 100%;
    height: 32px;
    padding: 8px 24px;
    border-radius: 24px;
    border: none;
    background: #dedede;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    flex: 0 0 68%;
  } */
</style>
